import { render } from "./List.vue?vue&type=template&id=33a4b51b"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "D:\\server\\www\\greativ\\ui\\template\\superSkypark\\moduleTmpl\\roomRent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__